<script setup lang="ts">
import { toRefs } from 'vue';
import type { DataTableCellProps } from '@common';
import type { YieldSoilParameterParameterData } from '../../models';

const props = defineProps<DataTableCellProps<any, YieldSoilParameterParameterData>>();
const { item } = toRefs(props);
</script>

<template>
  <v-chip
    v-if="item.data.strength"
    :color="item.data.strengthColor">
    {{ $t(`statistics.strength.${item.data.strength}`) }}
  </v-chip>
  <span v-else>-</span>
</template>
